import { brandBlack, brandRed, grey3 } from "./colors";

import { createTheme } from "@mui/material/styles";

export const defaultTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: brandRed.toString(),
    },
    secondary: {
      main: brandBlack.toString(),
    },
  },
  components: {
    MuiInput: {
      defaultProps: {
        disableUnderline: true,
      },
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: true,
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation2: {
          boxShadow: "none",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: brandBlack.toString(),
          fontSize: "16px",
          fontWeight: "600",
          letterSpacing: "0.02em",
          "&$disabled": {
            color: "black important!",
          },
        },
        asterisk: {
          color: brandRed.toString(),
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: "0px !important",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          border: `solid 2px ${grey3.toString()}`,
          borderRadius: "0px !important",
          margin: "0.25rem 0",
          color: brandBlack.toString(),
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          lineHeight: "14px",
          color: brandBlack.toString(),
        },
        outlined: {
          border: `solid 1px ${brandBlack.toString()}`,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          paddingTop: "0rem !important",
          paddingLeft: "0rem !important",
          paddingBottom: "0rem !important",
        },
        input: {
          paddingTop: "1rem !important",
          paddingLeft: "1rem !important",
          paddingBottom: "1rem !important",
        },
      },
    },
  },
  mixins: {},
});
